import { render, staticRenderFns } from "./Footer.vue?vue&type=template&id=20500ece&"
import script from "./Footer.js?vue&type=script&lang=js&"
export * from "./Footer.js?vue&type=script&lang=js&"
import style0 from "./Footer.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports